import { FIELD_TYPE } from '@/constants'

import { getFirstName, getLabelName } from '../helper'

export default {
  apiKey: 'authorization.helperDetails',
  //elemId: 'helperDetailsScroll',
  type: FIELD_TYPE.COLLECTION,
  collapsible: true,
  showLine: true,
  description(application) {
    return getLabelName(
      'Please initial the document if you had any assistance filling out the form, or if anyone translated or read any parts of the form to you. Please also provide the name and phone number of the person that helped you.'
    )
  },
  heading(contactItem, index) {
    return 'Helper ' + index
  },
  headingAdd: 'Add another helper',
  headingAddOutline: true,
  newItem: {
    helperRecordNo: null,
    helperName: '',
    heplerPhone: '',
    helperRelationship: ''
  },
  fields(helperItem, helperIndex) {
    var apiKeyPrefix = `${this.apiKey}[${helperIndex}]`

    return [
      {
        apiKey: apiKeyPrefix + '.helperName',
        label: `Helper Name`,
        placeHolder: "Enter Helper Name",
        description: 'Helper Full Name',
        required() {
          return (
            (helperItem.helperName ||
              helperItem.helperRelationship) &&
            !helperItem.helperName
          )
        },
        validation(value) {
          if (!/^[a-zA-Z ()'-]+$/.test(value)) {
            return `Can only contain letters, spaces, and - ( ) '`
          }
        },
        maxLength: 132
      },      
      {
        apiKey: apiKeyPrefix + '.heplerPhone',
        label: 'Phone Number',
        placeHolder: '(123) 456-7890',
        description: "Format: (123) 456-7890",
        type: FIELD_TYPE.PHONE,
        maxLength: 14,
        validation(value) {     
          if (!/^\d{10}$/.test(value.replace(/[^a-zA-Z0-9]+/g,''))) {
            return 'Please enter minimum 10 digits.'
          }
        }
      },
      {
        apiKey: apiKeyPrefix + '.helperRelationship',
        label: 'Relationship to Client',        
        description: "Relationship to Client"        
      }
    ]
  }
}
